import getLocalizedPathFromApi from '@/core/utils/locale/get-localized-path-from-api';
import pathWithSearch from '@/core/utils/path-with-search';
import sanitizeLocalizedPathForNonEvaTarget from '@/core/utils/sanitize-localized-path-for-non-eva';

type BuildTargetPathForLocaleArgs = {
  pathname: string;
  currentLocale: string;
  targetLocale: string;
  evaCountryIds: readonly string[];
  search?: string;
};

/**
 * Resolves the localized path for a target locale, sanitizing browse-only markets.
 */
export default async function buildTargetPathForLocale({
  pathname,
  currentLocale,
  targetLocale,
  evaCountryIds,
  search,
}: BuildTargetPathForLocaleArgs): Promise<string> {
  const resolvedPath = await getLocalizedPathFromApi(
    pathname,
    currentLocale,
    targetLocale,
  );
  const pathForTargetLocale = sanitizeLocalizedPathForNonEvaTarget(
    resolvedPath,
    targetLocale,
    evaCountryIds,
  );
  const didFallbackToBrowseOnlyRoute = pathForTargetLocale !== resolvedPath;

  if (didFallbackToBrowseOnlyRoute || !search) {
    return pathForTargetLocale;
  }

  return pathWithSearch(pathForTargetLocale, search);
}
